const mutations = {
  setPromptKvp(state, { key, title, content }) {
    window.Vue.set(state, key, { title, content });
  }
};

export default mutations;
